import React from 'react'

interface IDividerProps {
  orientation?: string
}

const Divider = ({ orientation = 'horizontal' }: IDividerProps) => {
  return <div className={`${orientation === 'vertical' && 'divider-vertical'} bb-shadow-grey`} />
}

export default Divider



// WEBPACK FOOTER //
// ./src/components/ui/Divider.tsx